var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVenuIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 3.83332C11.6666 4.7538 10.9205 5.49999 9.99998 5.49999C9.0795 5.49999 8.33331 4.7538 8.33331 3.83332C8.33331 2.91285 9.0795 2.16666 9.99998 2.16666C10.9205 2.16666 11.6666 2.91285 11.6666 3.83332Z",
    stroke: "#A4A8B5",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 17.1667C11.6666 18.0871 10.9205 18.8333 9.99998 18.8333C9.0795 18.8333 8.33331 18.0871 8.33331 17.1667C8.33331 16.2462 9.0795 15.5 9.99998 15.5C10.9205 15.5 11.6666 16.2462 11.6666 17.1667Z",
    stroke: "#A4A8B5",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6068 8.61003C15.8097 9.07027 14.7904 8.79714 14.3301 7.99999C13.8699 7.20283 14.143 6.18351 14.9402 5.72328C15.7373 5.26304 16.7566 5.53616 17.2169 6.33332C17.6771 7.13047 17.404 8.14979 16.6068 8.61003Z",
    stroke: "#A4A8B5",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05985 15.2767C4.26269 15.7369 3.24338 15.4638 2.78314 14.6667C2.3229 13.8695 2.59603 12.8502 3.39318 12.3899C4.19034 11.9297 5.20965 12.2028 5.66989 13C6.13013 13.7971 5.857 14.8165 5.05985 15.2767Z",
    stroke: "#A4A8B5",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9402 15.2767C14.143 14.8165 13.8699 13.7971 14.3301 13C14.7904 12.2028 15.8097 11.9297 16.6068 12.3899C17.404 12.8502 17.6771 13.8695 17.2169 14.6667C16.7566 15.4638 15.7373 15.7369 14.9402 15.2767Z",
    stroke: "#A4A8B5",
    strokeWidth: 1.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39318 8.61005C2.59603 8.14982 2.3229 7.1305 2.78314 6.33334C3.24338 5.53619 4.26269 5.26306 5.05985 5.7233C5.857 6.18354 6.13013 7.20286 5.66989 8.00001C5.20965 8.79717 4.19034 9.07029 3.39318 8.61005Z",
    stroke: "#A4A8B5",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenuIco);
export default __webpack_public_path__ + "static/media/venu-ico.123a3da94a5a9c09e9d211365bcec38c.svg";
export { ForwardRef as ReactComponent };